import { render, staticRenderFns } from "./VendorsFilesTab.vue?vue&type=template&id=91a536ea&scoped=true&"
import script from "./VendorsFilesTab.vue?vue&type=script&lang=js&"
export * from "./VendorsFilesTab.vue?vue&type=script&lang=js&"
import style0 from "./VendorsFilesTab.vue?vue&type=style&index=0&id=91a536ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a536ea",
  null
  
)

export default component.exports